import React, { useState, useEffect, useRef } from "react";
import { Thing } from "../../../interfaces/course";
import TrainingCard from "./trainingCard";

import "./trainingCardCarouse.scss";

import {
NextIconDisabled,
NextIconEnabled,
PrevIconDisabled,
PrevIconEnabled,
calculateCardsPerPage,
calculateCarouselLeftOffset,
replaceCarouselOffset,
replaceCardsPerPage

} from './utilityFunctions'
import { Source } from "@mui/icons-material";

export enum ProductType {
'Training Aids' = "Training Aids",
'Clubs' = 'Clubs'
}

function TrainingCardCarousel({
items,
carouselTitle,
width,
parentPage,
isSidebarOpen,
locationValue
}: {
items: Thing[];
carouselTitle: string;
width: number;
parentPage: string;
isSidebarOpen: boolean;
locationValue: string;
}) {
//console.log('TrainingCardCarousel rendered');

const [visibleCards, setVisibleCards] = useState<Thing[]>([]);
const [cardsPerPage, setCardsPerPage] = useState<number>(
calculateCardsPerPage(parentPage, isSidebarOpen)
);

//carouselLeftOffset is used to control the left offset of the carousel based on diferent screen sizes and filter state open/close
const [carouselLeftOffset, setCarouselLeftOffset] = useState(0);

const isMobile = window.innerWidth >= 768 ? false : true;

const isIOS = () => {
const ua = navigator.userAgent;
// legacy iOS (iPhone/iPad/iPod)
if ( /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream ) {
return true;
}
// iPadOS 13+ Safari detection
if (/\bMacintosh\b/.test(ua) && navigator.maxTouchPoints > 1) {
return true;
}
return false;
};

const [isNextDisabled, setIsNextDisabled] = useState(false);
const [isPrevDisabled, setIsPrevDisabled] = useState(true);
const [firstItemIndex, setFirstItemIndex] = useState<number>(0);

const [activeArrowButton, setActiveArrowButton] = useState<HTMLElement>();
const [smallerThan768, setSmallerThan768] = useState<boolean>(false);
const [showedItems, setShowedItems] = useState<Thing[]>(items.slice(firstItemIndex, cardsPerPage));
const carouselRef = useRef<HTMLDivElement>(null);
const [carouselLeftStyle, setCarouselLeftStyle] = useState<string>("0px");
const isHalfCardCase =
  items.length === Math.ceil(cardsPerPage);
const maxIndex = Math.max(
  items.length - Math.ceil(cardsPerPage) + 1,
  0
);

useEffect(() => {
const carousels = document.querySelectorAll<HTMLElement>(
".carouselAndTitleAndArrowsContainer"
);
const main = document.querySelector(
".mainCoursesContainer"
) as HTMLElement | null;

if (!main || carousels.length === 0) return;

const updateHeights = () => {
let mainTotalHeight = 300;

carousels.forEach(carousel => {
const header = carousel.querySelector<HTMLElement>(".jcsb");
const cards = carousel.querySelectorAll<HTMLElement>(
".cardHolderInner:not(.hovered)"
);

if (!header || cards.length === 0) return;

let maxCardHeight = 0;

cards.forEach(card => {
maxCardHeight = Math.max(
maxCardHeight,
card.getBoundingClientRect().height
);
});

const totalHeight =
header.getBoundingClientRect().height + maxCardHeight;

carousel.style.height = `${totalHeight}px`;

mainTotalHeight += totalHeight;
});

main.style.height = `${mainTotalHeight}px`;
};

updateHeights();

const ro = new ResizeObserver(updateHeights);

carousels.forEach(carousel => {
ro.observe(carousel);

const cards = carousel.querySelectorAll(".cardHolderInner:not(.hovered)");
cards.forEach(card => ro.observe(card));
});

return () => ro.disconnect();
}, []);

useEffect(() => {
setCardsPerPage(calculateCardsPerPage(parentPage, isSidebarOpen));
calculateCarouselLeftOffset(isMobile, parentPage, isSidebarOpen, setCarouselLeftOffset);

if (window.innerWidth < 768) {
setCarouselLeftStyle('0px');
setSmallerThan768(true);
} else {
if (smallerThan768) {
setSmallerThan768(false);
setFirstItemIndex(0);
}
}

if (activeArrowButton) {
setCarouselLeftStyle('0px');
if (cardsPerPage <= visibleCards.length) {
setIsNextDisabled(false);
}
}
}, [width, isSidebarOpen, smallerThan768, activeArrowButton, cardsPerPage, visibleCards.length]);

useEffect(() => {
//console.log(replaceCardsPerPage(cardsPerPage), firstItemIndex, items.length);
if (firstItemIndex > replaceCardsPerPage(cardsPerPage) && items.length - firstItemIndex < replaceCardsPerPage(cardsPerPage)) {
setFirstItemIndex(items.length - replaceCardsPerPage(cardsPerPage));
}

/* //console.log(activeArrowButton,'______');
let carousels: NodeListOf<HTMLElement> = document.querySelectorAll(".carouselContainer");

carousels.forEach((carousel, index) => {

let cardHolderContainer: NodeListOf<HTMLElement> | null = carousel.querySelectorAll(".cardHolderContainer");
if (carousel.style.left === "0px") {
//console.log('ovde 0');
carousel.style.left = "0px";

let cardHolderContainer: NodeListOf<HTMLElement> | null = carousel.querySelectorAll(".cardHolderContainer");
removeHoverPointer(cardHolderContainer[0])
addHoverPointer(cardHolderContainer[cardHolderContainer.length - 1])


} else if (carousel.style.left !== '' && typeof carousel.style.left !== 'undefined' && carousel.style.left !== null) {
carousel.style.left = `${replaceCarouselOffset(cardsPerPage)}px`;
setIsNextDisabled(true);
disableNextIcon(carousel)
let cardHolderContainer: NodeListOf<HTMLElement> | null = carousel.querySelectorAll(".cardHolderContainer");
addHoverPointer(cardHolderContainer[0])
removeHoverPointer(cardHolderContainer[cardHolderContainer.length - 1])

}

}) */

}, [isSidebarOpen]);
useEffect(() => {
const updatedItems = items.map((item, index) => {
if (index === 0) {
return { ...item, is_first: true };
} else if (index === items.length - 1) {
return { ...item, is_last: true };
} else {
return item;
}
});


setVisibleCards(
  isMobile
    ? updatedItems
    : updatedItems.slice(
        firstItemIndex,
        firstItemIndex + Math.ceil(cardsPerPage)
      )
);

showVisibleCards()

}, [isMobile, items, cardsPerPage, firstItemIndex]);

useEffect(() => {
//za filter chagnes

setFirstItemIndex(0);
setCarouselLeftStyle("0px");
setIsNextDisabled(false);
setIsPrevDisabled(true);
}, [items]);

useEffect(() => {
  const allCardsFit = items.length <= cardsPerPage;

  if (!isSidebarOpen && allCardsFit) {
    setFirstItemIndex(0);
    setCarouselLeftStyle("0px");
    setIsNextDisabled(true);
    setIsPrevDisabled(true);
  }
}, [isSidebarOpen, items.length, cardsPerPage]);

useEffect(() => {
  if (firstItemIndex > maxIndex) {
    setFirstItemIndex(maxIndex);
  }
}, [isSidebarOpen, cardsPerPage, items.length, maxIndex]);

useEffect(() => {

setVisibleCards(
isMobile
? items
: showedItems
);
}, [showedItems])


useEffect(() => {
if (firstItemIndex >= maxIndex) {
  setIsNextDisabled(true);
} else {
  setIsNextDisabled(false);
}

if (firstItemIndex === 0) {
setIsPrevDisabled(true);
} else {
setIsPrevDisabled(false);
}

showVisibleCards()

}, [firstItemIndex, items.length, cardsPerPage, carouselLeftOffset])

const showVisibleCards = () => {
  const sliceStart =
    !isSidebarOpen && firstItemIndex > 0
      ? firstItemIndex - 1
      : firstItemIndex;

  setShowedItems(
    items.slice(
      sliceStart,
      sliceStart + Math.ceil(cardsPerPage)
    )
  );
};

const handleNextPage = (event: React.MouseEvent<HTMLElement>) => {

if (event.currentTarget.classList.contains('Mui-disabled')) return;

if (firstItemIndex >= maxIndex) return;

const step = Math.max(Math.ceil(cardsPerPage) - 1, 1);
setFirstItemIndex(prev => Math.min(prev + step, maxIndex));

setActiveArrowButton(event.currentTarget as HTMLElement);
};

const handlePrevPage = (event: React.MouseEvent<HTMLElement>) => {

if (event.currentTarget.classList.contains('Mui-disabled')) return;

const step = Math.max(Math.ceil(cardsPerPage) - 1, 1);
setFirstItemIndex(prev => Math.max(prev - step, 0));

setActiveArrowButton(event.currentTarget as HTMLElement);
};
const parentPageUrl = parentPage === 'dash' ? 'my-game' : 'courses';
const ExploreAllFromCategory = (url: string) => {
const exploreUrl = carouselTitle
.replace(/ /g, "-")
.replace(/[^a-zA-Z0-9-%]/g, '')
.toLowerCase();
window.location.href = `/${parentPageUrl}/${url}/${exploreUrl}`;
};

const viewExp = () => {
if (isSidebarOpen) {
return false;
}

if(Object.values(ProductType).includes(carouselTitle as ProductType)){
return false;
}

if (window.location.pathname.includes('scratch-club')) {
return false;
}

if (window.innerWidth < 1280 && (cardsPerPage * 2 - 1) <= items.length) {
return true;
} else if ((cardsPerPage * 2) < items.length) {
return true;
}

return false;
};

const getDisplayTitle = () => {
if (locationValue === "Footer") {
return "";
}
if (isMobile && carouselTitle.includes('Performance Golf')) {
return carouselTitle.replace(/Performance Golf/g, 'PG');
}
return carouselTitle;
};

return (
<>
<div className="df aie jcsb w-100">
<h2 className="courseCarouselTitle"
style={{
fontSize: locationValue == "Footer" ? "22px" : "",
fontFamily: locationValue == "Footer" ? "Repro" : "",
fontWeight: locationValue == "Footer" ? 500 : "",
}}
>{locationValue == "Footer" ? "POPULAR ON PERFORMANCE GOLF" : carouselTitle}</h2>
{ viewExp()
&& (

<span className="exploreAll" onClick={() => {ExploreAllFromCategory(`explore-all`)}}>
<span style={{ display: isMobile ? 'none' : '' }}>Explore All</span>
<img style={{ transform: isMobile ? 'translate(-15px, 15px)' : '0' }} src="https://members.performancegolf.com/wp-content/uploads/2025/12/vector-right-gray.png" alt=""/>
</span>
)}
{!isMobile ? (
items.length > cardsPerPage - 0.5 ? (
<div className="posRelative carouselArrowsContainer">
<div className="carouselArrows noSelect">
<div
onClick={handlePrevPage}
className={firstItemIndex === 0 ? "prevButton Mui-disabled" : "prevButton"}
>
{
firstItemIndex === 0 ?
<img src={PrevIconDisabled} /> :
<img src={PrevIconEnabled} />
}
</div>
<div
  onClick={handleNextPage}
 className={
  firstItemIndex >= maxIndex
    ? "nextButton Mui-disabled"
    : "nextButton"
}
>
  {
      firstItemIndex >= maxIndex
      ? <img src={NextIconDisabled} />
      : <img src={NextIconEnabled} />
  }
</div>
</div>
</div>
) : (
<div className="posRelative carouselArrowsContainer" style={{ visibility: 'hidden', width: '90px' }}>
<div className="carouselArrows noSelect">
<div className="prevButton"></div>
<div className="nextButton"></div>
</div>
</div>
)
) : null}
</div>

<div
id="container"
ref={carouselRef}
className={isSidebarOpen ? "carouselContainer isSidebarOpen" : "carouselContainer"}
style={{
marginBottom: '0px',
paddingBottom: '0px',
// maxHeight: '440px',
left: carouselLeftStyle
}}
>
<div
className="carouselFrame"
style={{
marginBottom: '0px',
paddingBottom: '0px',
transform:
  firstItemIndex > 0
    ? isSidebarOpen
      ? `translateX(calc(-100% / (${cardsPerPage - 0.5} * 4)))`
      : `translateX(calc(-100% / (${cardsPerPage - 0.5} * 2)))`
    : 'translateX(0px)',

transition: 'transform 0.3s ease'
}}
>
{visibleCards.map((item, index, visibleCards) => {
const shouldInitialHover =
carouselTitle.endsWith("s Training Programs") &&
index === 0 &&
(isMobile || isIOS());
return index === visibleCards.length - 1 ? (
<TrainingCard
key={item.ID}
accelerator={item}
isSidebarOpen={isSidebarOpen}
carouselTitle={carouselTitle}
cardWidth={`calc(100% / ${cardsPerPage - 0.5})`} locationValue={locationValue}
hoverPointer={
  visibleCards.length === cardsPerPage &&
  firstItemIndex === 0
}
leftHoverPointer={
  index === 0 &&
  firstItemIndex > 0
}
source={locationValue}
initialHover={shouldInitialHover}
/>
) : (
<TrainingCard
key={item.ID}
accelerator={item}
carouselTitle={carouselTitle}
cardWidth={`calc(100% / ${cardsPerPage - 0.5})`} locationValue={locationValue}
hoverPointer={
  visibleCards.length === cardsPerPage &&
  index === visibleCards.length - 1 &&
  firstItemIndex === 0
}
source={locationValue}
initialHover={shouldInitialHover}
isSidebarOpen={isSidebarOpen}
leftHoverPointer={
  index === 0 &&
  firstItemIndex > 0
}
/>
)
}
)}
</div>
</div>
</>
);
}

export default TrainingCardCarousel;


